import React from 'react';
import StopSpam from '@components/pages/products/stop-spam';

const StopSpamPage = () => <StopSpam />;

export default StopSpamPage;
